import React, { useEffect } from "react";
import { withUser } from "@coverme/identity";
import { connect } from "react-redux";
import { LoadingBar } from "../../components/LoadingComponents/LoadingBar";
import { Link } from "react-router-dom";
import { useFilters } from "../../hooks/useFilters";
import { RetrocheckFileRecordsTable } from "../../components/Retrocheck/RetrocheckFileRecordsTable";
import { RetrocheckFileInfoFilters } from "../../components/Retrocheck/RetrocheckFileInfoFilters";
import { RetrocheckFileSummary } from "../../components/Retrocheck/RetrocheckFileSummary";
import { Birdseed } from "@coverme/elements";
import "../../components/Retrocheck/Retrocheck.scss"
import * as retrocheckActions from "../../actions/retrocheckActions";
import { CTA } from "@coverme/forms"

export const RetrocheckFileInfoComponent = ({
    files,
    fileName,
    fileSummary,
    getFileSummary,
    getFileRecords,
    customerId,
    fileRecords,
    updateRetrocheckFilter,
    fileId
}) => {
    const isLoading = fileSummary.isLoading || !fileSummary.isInitialized;
    const { filters, setFilters, onFetchData } = useFilters(
        {},
        fileId,
        getFileRecords,
        500,
        5
    );

    useEffect(() => {
        getFileSummary(fileId);
    }, [fileId]);

    function navigateBack() {
        window.history.back();
    }


    return (
        <div>
            <LoadingBar isLoading={isLoading}>
                <Birdseed>
                    <Link to="/" className="link">
                        Home
                    </Link>
                    <Link to="/retrocheck" className="link">
                        Retrocheck
                    </Link>
                    <a href="javascript:void(0)">File View {fileName ? "- " + fileName : ""}</a>
                </Birdseed>

                <div className="retrocheckUpload">
                    <div className="retrocheck__summary-back-button-alignment">
                        <h2>Summary</h2>
                        <CTA ctaType={"button"} click={navigateBack} styleType={"blue"} size={"large"} disabled={false}>
                            Back
                        </CTA>
                    </div>
                    <RetrocheckFileSummary
                        fileSummary={fileSummary?.data.data}
                    />
                </div>

            </LoadingBar>
            <div className="filter-heading-alignment">
                <h2>Filters</h2>
            </div>

            <div className="filters">
                <RetrocheckFileInfoFilters
                    submitFilter={setFilters}
                />
            </div>

            <RetrocheckFileRecordsTable
                pagedFiles={fileRecords}
                onFetchData={onFetchData}
                isLoading={fileRecords.isLoading}
            />
        </div>
    );
};

export const RetrocheckFileInfoContainerWithUser = withUser(RetrocheckFileInfoComponent);

export const RetrocheckFileInfoContainer = connect(
    (state, ownProps) => ({
        fileRecords: state.retrocheckFileRecords,
        customerId: state.customer?.data?.customer?.GlobalId,
        fileId: ownProps.match.params.fileId,
        fileSummary: state.retrocheckFileSummary,
        fileName: state.retrocheckFileSummary?.data?.data?.fileName,

    }),
    dispatch => ({
        getFileSummary: (fileId) => dispatch(retrocheckActions.getFileSummary(fileId)),
        getFileRecords: (fileId, query, cancellationToken) =>
            dispatch(retrocheckActions.getFileRecords(fileId, query, cancellationToken)),
        updateRetrocheckFilter: (filter, query) => dispatch(retrocheckActions.updateFileFilter(filter, query)),
    })
)(RetrocheckFileInfoContainerWithUser);